import Card from "@rio-cloud/rio-uikit/Card";
import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";
import { RoundedLoader } from "./sharedSkeletonParts";

interface TopVehiclesMaintenanceTableSkeletonProps {
  items?: number;
}

const TITLE_LINE_HEIGHT = 23;
const TITLE_WIDTH = 280;
const HEADER_LINE_HEIGHT = 17;
const CELL_LINE_HEIGHT = 18;
const BAR_HEIGHT = 20;
const BAR_RADIUS = 4;

const HEADER_LOADER_CLASS = "display-block skeleton-on-light-bg";
const HEADER_WIDTHS = [53, 73, 66];
const VEHICLE_WIDTHS = [70, 90, 110, 100, 95];
const BAR_WIDTHS = ["100%", "42%", "35%", "35%", "35%"];
const AMOUNT_WIDTHS = [68, 68, 62, 62, 62];
const COST_WIDTH = 45;

export default function TopVehiclesMaintenanceTableSkeleton({
  items = 5,
}: Readonly<TopVehiclesMaintenanceTableSkeletonProps>) {
  return (
    <Card className="padding-y-25 padding-x-15 padding-x-25-sm display-flex flex-column height-100pct">
      <div className="padding-bottom-20">
        <ContentLoader className="display-block" height={TITLE_LINE_HEIGHT} width={TITLE_WIDTH} />
      </div>
      <div className="table-responsive rounded border border-width-1 border-color-light">
        <table className="table margin-bottom-0">
          <thead>
            <tr className="bg-lightest">
              <th>
                <ContentLoader className={HEADER_LOADER_CLASS} height={HEADER_LINE_HEIGHT} width={HEADER_WIDTHS[0]} />
              </th>
              <th>
                <ContentLoader className={HEADER_LOADER_CLASS} height={HEADER_LINE_HEIGHT} width={HEADER_WIDTHS[1]} />
              </th>
              <th>
                <ContentLoader
                  className={`${HEADER_LOADER_CLASS} margin-left-auto`}
                  height={HEADER_LINE_HEIGHT}
                  width={HEADER_WIDTHS[2]}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: items }, (_, index) => (
              <tr key={index}>
                <td>
                  <ContentLoader
                    className="display-block"
                    height={CELL_LINE_HEIGHT}
                    width={VEHICLE_WIDTHS[index % VEHICLE_WIDTHS.length]}
                  />
                </td>
                <td style={{ width: "55%" }}>
                  <div className="display-flex align-items-center gap-10">
                    <RoundedLoader
                      height={BAR_HEIGHT}
                      width={BAR_WIDTHS[index % BAR_WIDTHS.length]}
                      radius={BAR_RADIUS}
                    />
                    <ContentLoader
                      className="display-block"
                      height={CELL_LINE_HEIGHT}
                      width={AMOUNT_WIDTHS[index % AMOUNT_WIDTHS.length]}
                    />
                  </div>
                </td>
                <td>
                  <ContentLoader
                    className="display-block margin-left-auto"
                    height={CELL_LINE_HEIGHT}
                    width={COST_WIDTH}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
